export default __webpack_public_path__ + "static/media/ic_Filter.e8928d59.svg";